<template>
  <div>
    <svg :height="width/2+60" width="100%" ref="svg">
      <defs>
        <clipPath id="clip">
          <rect x="0" y="0" :width="width" :height="width/2"/>
        </clipPath>
      </defs>
      <g clip-path="url(#clip)">
        <circle 
          :r="width/2" 
          :cx="width/2" 
          :cy="width/2" 
          :fill="slices.slice(-1)[0].color" />
        <circle 
          v-for="slice in slices" v-bind:key="slice.label"
          :r="width/4" 
          :cx="width/2" 
          :cy="width/2" 
          fill="transparent"
          :stroke="slice.color"
          :stroke-width="width/2"
          :stroke-dasharray="slice.size"
          :stroke-dashoffset="slice.offset"
           /> <!-- :transform="'rotate('+slice.rotation+') translate('+slice.translation+')'" -->
        <circle 
          :r="width/6" 
          :cx="width/2" 
          :cy="width/2" 
          fill="white" />
      </g>
      <g v-for="(row, index) in data.rows[0]" :key="'bar'+index">
        <text
          :x="getX(index)+barThickness/2" 
          :y="width/2 +25"
          text-anchor="middle"
          :font-size="fontSize"
        >
          {{row}}
        </text>
        <rect
          :x="getX(index)"
          :y="width/2 +30"
          :height="3"
          :width="barThickness" 
          :fill="data.cols[index].color" 
        />
        <text
          :x="getX(index)+barThickness/2" 
          :y="width/2 +50"
          text-anchor="middle"
          :font-size="fontSize"
        >
          {{elipsis(data.cols[index].label)}}
        </text>
      </g>
    </svg>
  </div>
</template>

<script>
// import {scaleLinear} from 'd3' //scaleTime, , format
import debounce from 'debounce'

export default {
  name: 'SeatChart',
  props: {
    data: Object,
    fontSize: { type: Number, default: 16 },
    barMargin: { type: Number, default: 5 },
  },
  data () {
    return {
      width: 600,
    }
  },
  methods: {
    fitProjection () {
      this.width = this.$refs.svg.getBoundingClientRect().width
    },
    elipsis (str) {
      let maxLength = parseInt(this.barThickness/9)
      if (str.length > maxLength) {
        return str.slice(0,maxLength) + '...'
      } else {
        return str
      }
    },
    // y (val) {
    //   let x = scaleLinear()
    //     .domain(this.yRangeComputed)
    //     .range([this.height-20, 20])
    //   return x(val)
    // },
    getX (index) {
      return index*this.barThickness + index*this.barMargin
    }
  },
  computed: {
    slices () {
      let seatsTotal = this.data.rows[0].reduce( (a, b) => { return a+b }, 0)
      let circle = this.width*Math.PI

      return this.data.cols.map( (col, index) => {
        let seats = this.data.rows[0][index]
        let seatsBefore = this.data.rows[0].slice(0,index).reduce( (a, b) => { return a+b }, 0)
        let ratio = seats/seatsTotal
        let ratioBefore = seatsBefore/seatsTotal
        return {
          label: col.label,
          color: col.color,
          seats: seats,
          ratio: ratio,
          ratioBefore: ratioBefore,
          size: `${Math.ceil(ratio*0.25*circle)} 1000`,
          offset: -Math.ceil(ratioBefore*0.25*circle) - 0.25*circle,
        }
      })
    },
    barThickness: function () {
      let n = this.data.cols.length
      return (this.width - this.barMargin*(n-1))/n
    }
  },
  mounted () {
    this.fitProjection()
    window.addEventListener('resize', debounce(this.fitProjection, 250))
    setTimeout(() => { this.fitProjection() }, 2000)
  },
  updated () {
    this.fitProjection()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>